import React from 'react';
import { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import EndorLabsCredentialsForm from './EndorLabsCredentialsForm';
import EndorLabsMappingForm from './EndorLabsMappingForm';
import _ from 'lodash';
import { CellRenderers } from 'utils/tableUtils';
import { DELIMITER } from './EndorLabsMappingForm';
import ContentOverlay from 'components/ContentOverlay';

const EndorLabsConfigListing = (props) => {

    const columns = useMemo(() => [
        {
            title: "Tenant",
            dataIndex: "tenantName",
            width: 240,
        },
        {
            title: "Namespace",
            dataIndex: "namespaceName",
            width: 240,
            render: (project, record) => {
                if (_.isEmpty(project)) {
                    return CellRenderers.VALUE_OR_NA(project)
                }

                const nameSpaces = _.split(project, ',');
                const projectObj = {}

                _.forEach(nameSpaces, project => {
                    const index = project.lastIndexOf(DELIMITER)
                    const _project = project.substring(0, index === -1 ? undefined : index);
                    if (index !== -1) {
                        const references = project.substring(index + 1, project.length);
                        projectObj[_project] = _.split(references.replace(/;/g, ', '), ',')
                    } else {
                        projectObj[_project] = undefined
                    }

                })

                const renderName = Object.keys(projectObj).map(item => projectObj[item] ? `${item} - [${projectObj[item]}]` : item)


                const content = renderName.map(item => <p>{item}</p>)

                return <ContentOverlay content={content} minHeight={40} />
            }
        }], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={EndorLabsMappingForm}
            CredentialsForm={EndorLabsCredentialsForm}
            extraColumns={columns}
        />
    );
}

export default EndorLabsConfigListing;
